// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"bK-z","carouselContainer":"cK-z"};